import React from 'react';
import { Container, CaixaUpload, ContainerImg, TextAttachment, TextInfo } from './styles';
import { Upload, notification } from 'antd';
import { SKW_AUTH, SKW_PREFIX, SKW_URL } from '../../../../../utils/constants';
import anexoImg from '../../../../../assets/img/anexo.png';

const Attachement: React.FC = () => {
  function onRemoveFile(info: any) {
    const hash = info.response[0].filekey;
    const anexos: any = JSON.parse(
      localStorage.getItem(window.location.pathname + `ListaAnexos`) || '[]'
    );
    // eslint-disable-next-line array-callback-return
    anexos.map((item: any) => {
      let index = anexos.indexOf(item);
      if (item.key === hash) {
        anexos.splice(index, 1);
      }
    });
    localStorage.setItem(window.location.pathname + 'ListaAnexos', JSON.stringify(anexos));
  }

  const openNotification = (message: string) => {
    notification.info({
      message,
      placement: 'bottomRight',
    });
  };

  const customRequest = (info: any) => {
    const { file } = info;
    const formData = new FormData();
    formData.append(file.name, file);
    const xhr = new XMLHttpRequest();
    xhr.open(
      'POST',
      `${SKW_URL}/upload?serviceName=${SKW_PREFIX}novaMensagem&accessKey=${SKW_AUTH}`,
      true
    );
    xhr.send(formData);
    xhr.onload = function () {
      if (xhr.status === 200) {
        info.onSuccess(JSON.parse(xhr.response), info.file);
      } else {
        info.onError(JSON.parse(xhr.response), info.file);
      }
    };
  };

  const handleChange = (info: any) => {
    const { status } = info.file;
    const { name } = info.file;
    let sizeFile = (info.file.size / 1048576).toFixed(1);

    if (status === 'done' && +sizeFile > 5.0) {
      openNotification(`o arquivo não pode ser maior que 5MB.`);
      return (info.file.status = 'error');
    }

    if (status === 'done') {
      const { filekey } = info?.file?.response[0];
      const listaAnexos: any = JSON.parse(
        localStorage.getItem(window.location.pathname + `ListaAnexos`) || '[]'
      );
      localStorage.setItem(
        window.location.pathname + 'ListaAnexos',
        JSON.stringify([
          ...listaAnexos,
          {
            key: filekey,
            status: 'done',
            nome: name,
          },
        ])
      );
      return openNotification(`Arquivo segue em anexo`);
    } else if (status === 'error') {
      return openNotification(`${name} não pode ser enviado.`);
    }
  };

  const props = {
    showUploadList: {
      showRemoveIcon: true,
    },
  };

  return (
    <Container>
      <Upload
        {...props}
        multiple={false}
        accept=".xml,.pdf,.doc,.xls,.xlsx,.csv,.png,.jpg,.jpeg,.rar,.zip"
        listType="picture"
        className="upload-list-inline"
        onChange={handleChange}
        onRemove={onRemoveFile}
        customRequest={customRequest}
      >
        <CaixaUpload>
          <ContainerImg>
            <img src={anexoImg} alt="Adicionar anexos" />
          </ContainerImg>
          <TextAttachment>Clique ou arraste o arquivo para fazer o upload</TextAttachment>

          <TextInfo>Tamanho máximo de 5MB por arquivo</TextInfo>
        </CaixaUpload>
      </Upload>
    </Container>
  );
};

export default Attachement;
